import { useEffect, useState } from "react";
import moment from "moment";
import TableWithSkeleton from "../../../../components/table/TableWithSkeleton";
import recentTransactionColumns from "../../../../columns/recentTransaction.jsx";

const RecentTableMobile = ({ data }) => {
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    const transactionData = [
      ...(data?.lastFiveDeposit || []),
      ...(data?.lastFiveWithdrawal || []),
    ];

    setFilteredData(
      transactionData?.map((item) => {
        return {
          ...item,
          amount: `$ ${item?.amount}`,
          transactionDate: item?.transactionDate
            ? moment(item?.transactionDate).format("DD-MM-YYYY LT")
            : null,
          status: (
            <span
              className={`px-3 py-1 rounded-full uppercase text-xs text-center ${
                item?.status === "Success" ? "success_tag" : "fail_tag"
              }`}
            >
              {item?.status}
            </span>
          ),
        };
      })
    );
  }, [data]);

  return (
    <div className="bg-white rounded-2xl p-4">
      <div className="flex items-center pb-4  justify-between mb-3 border-b border-gray-200">
        <h3 className="text-lg font-bold text-gray-600">Recent Transactions</h3>
      </div>
      <div className="bg-white rounded-lg overflow-hidden  pt-2">
        <TableWithSkeleton
          columns={recentTransactionColumns}
          data={filteredData}
          loading={!filteredData?.length}
        />
      </div>
    </div>
  );
};

export default RecentTableMobile;
